import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { TweenMax, TimelineMax, Power4 } from "gsap";
import { TransitionPortal } from "gatsby-plugin-transition-link";

import WebsiteContainer from "./WebsiteContainer";
import { Div, StyleReset, ThemeProvider } from "atomize";

import theme from "../common/theme";

import "../../styles/scss/style.scss";

class Layout extends Component {
  // const Layout = ({ headerFixed, children }) => {

  componentDidMount() {
    const loaderDiv = document.getElementById("loading");
    const mainContent = document.getElementById("main");

    if (document.body.classList.value === "loaded") {
      TweenMax.set(mainContent, { opacity: "1" });

      return;
    }

    const seconds = "1.5";
    const directionTo = "-100%";
    const directionFrom = "100%";
    const wait = seconds / 6;
    const half = (seconds - wait) / 2;

    var tl = new TimelineMax();
    tl.set(mainContent, {
      opacity: "0",
    })
      .set(loaderDiv, {
        y: directionFrom,
        background: "#222222",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        zIndex: "1000",
      })
      .to(loaderDiv, half, {
        y: "0%",
        ease: Power4.easeInOut,
      })
      .set(mainContent, { opacity: "1" })
      .to(loaderDiv, half, {
        y: directionTo,
        ease: Power4.easeIn,
        onStart: () => {
          document.body.classList.add("loaded");
        },
      });
  }

  render() {
    const { headerFixed, children } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <StyleReset />
        {/* to add loader, add loading section*/}
        {/* <div id="loading"></div>  */}
        {/* to add loader, add id="main" and opacity="0" */}
        <Div tag="main" bg="black" p={{ t: { xs: "57px", lg: "60px" } }}>
          <Div minH="100vh">
            <Div textColor="white">
              <div>
                <main>{children}</main>
              </div>
            </Div>
          </Div>
        </Div>
        {/* <div id="transitionSection" /> */}
        <TransitionPortal>
          <div id="transitionSection" />
        </TransitionPortal>
      </ThemeProvider>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
